import { useState } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { DSIcon } from '@spotahome/ui-library/base';
import IconButton from '@spotahome/ui-library/src/tenant/components/IconButton';
import { Tabs } from '@spotahome/ui-library';

import { capitalizeFirstLetter } from '@spotahome/marketplace-common/src/utils/stringUtils';

import DropdownTabs from './DropdownTabs';
import VerticalBarChart from './VerticalBarChart';

import './ChartContainer.scss';
import Table from './Table';

// TODO: Remove this data and get it from the backend
const availabilityData = [
  {
    month: 'Sep 24',
    all: 25,
    apartments: 5,
    studios: 25,
    rooms: 5,
    student: 25
  },
  {
    month: 'Oct 24',
    all: 30,
    apartments: 20,
    studios: 30,
    rooms: 20,
    student: 30
  },
  {
    month: 'Nov 24',
    all: 87,
    apartments: 67,
    studios: 87,
    rooms: 67,
    student: 87
  },
  {
    month: 'Dec 24',
    all: 30,
    apartments: 10,
    studios: 30,
    rooms: 10,
    student: 30
  },
  {
    month: 'Jan 25',
    all: 30,
    apartments: 0,
    studios: 30,
    rooms: 0,
    student: 30
  },
  {
    month: 'Feb 25',
    all: 27,
    apartments: 17,
    studios: 27,
    rooms: 17,
    student: 27
  }
];

const ChartContainer = ({ location, isMobile = false }) => {
  const [isViewTable, setIsViewTable] = useState(false);

  const handleToggleView = () => {
    setIsViewTable(prev => !prev);
  };

  const getChartData = category => {
    return availabilityData.map(item => ({
      label: item.month,
      available: item[category]
    }));
  };

  const chartSections = [
    {
      id: 'all',
      label: trans('charts.section.all-properties'),
      render: () => (
        <div key="all">
          <VerticalBarChart data={getChartData('all')} />
        </div>
      )
    },
    {
      id: 'apartments',
      label: trans('charts.section.apartments'),
      render: () => (
        <div key="apartments">
          <VerticalBarChart data={getChartData('apartments')} />
        </div>
      )
    },
    {
      id: 'studios',
      label: trans('charts.section.studios'),
      render: () => (
        <div key="studios">
          <VerticalBarChart data={getChartData('studios')} />
        </div>
      )
    },
    {
      id: 'rooms',
      label: trans('charts.section.rooms-shared'),
      render: () => (
        <div key="rooms">
          <VerticalBarChart data={getChartData('rooms')} />
        </div>
      )
    },
    {
      id: 'student',
      label: trans('charts.section.student-residences'),
      render: () => (
        <div key="student">
          <VerticalBarChart data={getChartData('student')} />
        </div>
      )
    }
  ];

  const tableSections = chartSections.map(section => ({
    ...section,
    render: () => <Table />
  }));

  return (
    <div className="chart-container">
      <div className="chart-container__header">
        <h2 className="chart-container__header-title">
          {trans('chart.availability.title', { city: location.city })}
        </h2>
        <IconButton
          onClick={handleToggleView}
          className="chart-container__header-button"
        >
          {isViewTable ? (
            <>
              <DSIcon name="stats_figures" />
              <span>{trans('charts.button.toggle.chart-view')}</span>
            </>
          ) : (
            <>
              <DSIcon name="format_list_bulleted" />
              <span>{trans('charts.button.toggle.table-view')}</span>
            </>
          )}
        </IconButton>
      </div>

      <p className="chart-container__subtitle">
        {trans('chart.availability.subtitle', {
          city: location.city,
          country: capitalizeFirstLetter(location.country)
        })}
        <span className="chart-container__subtitle-highlight">46%</span>
      </p>

      <div className="chart-container__chart">
        {isMobile ? (
          <DropdownTabs
            className="chart-container__chart-tabs"
            items={isViewTable ? tableSections : chartSections}
            variant={'outlined'}
            handleOnClick={handleToggleView}
            isViewTable={isViewTable}
          />
        ) : (
          <Tabs
            className="chart-container__chart-tabs"
            items={isViewTable ? tableSections : chartSections}
            variant={'outlined'}
          />
        )}
      </div>

      <p className="chart-container__description">
        {trans('chart.availability.summary', {
          city: location.city,
          month: 'February', // TODO: get month from data
          percentage: '46' // TODO: get percentage from data
        })}
      </p>
    </div>
  );
};

export default ChartContainer;

ChartContainer.propTypes = {
  isMobile: PropTypes.bool,
  location: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string
  }).isRequired
};
